"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const ScenarioType_1 = require("../../enums/ScenarioType");
const UserIdentifyingFieldType_1 = require("../../enums/UserIdentifyingFieldType");
const ElementIds_1 = require("../../enums/ElementIds");
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const UserIdentifyingFieldGroup_vue_1 = tslib_1.__importDefault(require("../confirmIdentity/UserIdentifyingFieldGroup.vue"));
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'confirm-identity',
    data() {
        return {
            showNotification: false,
            fieldValidationStatus: new Map(),
            hasInvalidField: true,
        };
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        async submitForm() {
            if (this.submitting) {
                return;
            }
            const challenge = {
                ...this.confirmIdentityChallenge,
            };
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            // submit the challenge
            await this.$store.dispatch('submitChallenge', challenge);
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                // filter down to just fields that have data
                const datapoints = challenge.Scenario.FieldGroups
                    .reduce((acc, val) => acc.concat(val.Fields), [])
                    .filter(x => x.Value !== null && typeof x.Value === 'string' && x.Value.trim().length > 0);
                let properties = {
                    'numDataPoints': datapoints.length,
                };
                if (this.$store.getters.hasInvalidChallengeStatus) {
                    properties.error = this.$store.getters.challengeStatus;
                }
                void userTelemetry_1.telemetry.custom({
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.confirm_your_identity,
                    action: userTelemetry_1.userAction.continue_clicked,
                    eventProperties: properties,
                });
            }
        },
        notificationMessage() {
            return this.getSiteText(`${this.scenarioType}.ConfirmIdentity.Notification`);
        },
        validationCheck(data) {
            this.fieldValidationStatus.set(UserIdentifyingFieldType_1.UserIdentifyingFieldType[data.fieldType], data.isValid);
            let hasInvalidStatus = false;
            for (let value of this.fieldValidationStatus.values()) {
                if (!value) {
                    hasInvalidStatus = true;
                    break;
                }
            }
            this.hasInvalidField = hasInvalidStatus;
        },
    },
    computed: {
        scenarioType() {
            return ScenarioType_1.ScenarioType[this.confirmIdentityChallenge.Scenario.ScenarioTypeValue];
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        confirmIdentityChallenge() {
            return this.$store.state.currentChallenge;
        },
        buttonDisabled() {
            return this.submitting || this.hasInvalidField;
        },
        elementIds: () => ElementIds_1.ElementIds,
    },
    mounted() {
        var _a;
        if (this.notificationMessage()) {
            this.showNotification = true;
        }
        // Fix an issue with the notification message close button causing the form to submit
        (_a = document.querySelector('[data-cy="notificationMessage"] button')) === null || _a === void 0 ? void 0 : _a.setAttribute('type', 'button');
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        UserIdentifyingFieldGroup: UserIdentifyingFieldGroup_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
